var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconMastercard = function SvgIconMastercard(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9095A7",
    d: "M11 2h8v15h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    d: "M11.47 9.5A9.61 9.61 0 0 1 15 2.032 9.087 9.087 0 0 0 9.278 0C4.15 0 0 4.249 0 9.5S4.15 19 9.278 19c2.165 0 4.15-.765 5.722-2.032-2.14-1.715-3.53-4.433-3.53-7.468zM30 9.5c0 5.251-4.15 9.5-9.278 9.5A9.087 9.087 0 0 1 15 16.968c2.165-1.742 3.53-4.433 3.53-7.468A9.61 9.61 0 0 0 15 2.032 9.087 9.087 0 0 1 20.722 0C25.85 0 30 4.275 30 9.5z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconMastercard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-mastercard.6a38a477.svg";
export { ForwardRef as ReactComponent };